import { authHeader } from '../helpers/auth-header';
import { client } from './';

const url = '/Request';

export const notesActions = {
    postNote,
    fetchNotes,
    setNoteVisibility,
    editNote,
};

function postNote(data, opt) {
    let rurl = url;
    rurl += '/add_new_note/' + opt;
    return client.post(rurl, data, { headers: authHeader() })
}

function fetchNotes(opt) {
    let rurl = url;
    rurl += '/request_notes/' + opt;
    return client.get(rurl, { headers: authHeader() })
}

function setNoteVisibility(id, isVisible) {
    let rurl = url;
    rurl += '/change_note_availability/' + id;
    return client.put(rurl, isVisible+'', { headers: authHeader() })
}

function editNote(id, note) {
    let rurl = url;
    rurl += '/edit_note';

    return client.put(rurl, {
        NoteId: id,
        Note: note
    }, { headers: authHeader() })
}
